import axios from 'axios';

const axiosInstance = axios.create({
  withCredentials: process.env.NODE_ENV === 'development' ? true : false,
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 3000,
  headers: {'Content-Type': 'application/json'}
});

export default axiosInstance;